
import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

const Sitemap = () => {
  useEffect(() => {
    generateSitemap();
  }, []);

  const generateSitemap = async () => {
    try {
      // Fetch all published blog posts
      const { data: posts, error } = await supabase
        .from("blog_posts")
        .select("slug, published_at")
        .eq("published", true);

      if (error) throw error;

      const baseUrl = "https://feednatic.com";
      const date = new Date().toISOString();

      // Static routes
      const staticUrls = [
        { url: "/", priority: "1.0" },
        { url: "/blog", priority: "0.9" },
      ];

      // Generate XML
      const urlset = [
        '<?xml version="1.0" encoding="UTF-8"?>',
        '<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">',
        // Add static URLs
        ...staticUrls.map(
          ({ url, priority }) => `
  <url>
    <loc>${baseUrl}${url}</loc>
    <lastmod>${date}</lastmod>
    <changefreq>weekly</changefreq>
    <priority>${priority}</priority>
  </url>`
        ),
        // Add blog post URLs
        ...(posts || []).map(
          (post) => `
  <url>
    <loc>${baseUrl}/blog/${post.slug}</loc>
    <lastmod>${post.published_at || date}</lastmod>
    <changefreq>monthly</changefreq>
    <priority>0.6</priority>
  </url>`
        ),
        "</urlset>",
      ].join("\n");

      // Create a Blob with the XML content
      const blob = new Blob([urlset], { type: "application/xml" });
      const url = URL.createObjectURL(blob);

      // Download the sitemap
      const a = document.createElement("a");
      a.href = url;
      a.download = "sitemap.xml";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error generating sitemap:", error);
    }
  };

  return (
    <div className="p-4">
      <h1>Generating sitemap.xml...</h1>
      <p>The sitemap will download automatically.</p>
    </div>
  );
};

export default Sitemap;
